import { colors } from '@insurancemenu/imenu-components-lib';
import ProductLineCard from 'components/common/general/ProductLineCard';
import styled from 'styled-components';

export const BenefitsSectionStyled = styled.section`
  border-radius: 1rem;
  padding: 2rem 3rem 4rem;
  background-color: ${colors.blue[100]};
  width: 100%;
  margin-top: 1rem;
`;

export const BenefitsTitleStyled = styled.h3`
  font-size: 2rem;
  line-height: 2.8rem;
  color: ${colors.neutral[900]};
  text-align: center;
  padding-bottom: 1rem;
  border-bottom: 1px solid ${colors.neutral[300]};
  margin: 0 0 3rem;
`;

export const BenefitsListStyled = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 2.4rem;
`;

export const ProductLineCardStyled = styled(ProductLineCard)`
  background-color: ${colors.neutral.white};
`;
